import type { DocumentTemplate } from '@/entities/templates';

// "New field", then "New field 2", "New field 3"…: the first name not taken.
const getFreeName = (base: string, taken: string[]) => {
  const names = taken.map((name) => name.trim());
  if (!names.includes(base)) {
    return base;
  }
  const number = Array.from(
    { length: names.length + 1 },
    (_, index) => index + 2,
  ).find((candidate) => !names.includes(`${base} ${candidate}`));
  return `${base} ${number}`;
};

export const getNewSectionTitle = (template: DocumentTemplate, base: string) =>
  getFreeName(
    base,
    template.sections.map((section) => section.Title),
  );

export type StructureItem = { kind: 'section'; code: string };

export const getStructureItemId = (item: StructureItem) =>
  JSON.stringify([item.kind, item.code]);
